/*
  Splits a mega menu category's flat link list into real sub-column <ul> elements.

  The column count comes from the class Liquid puts on the category <li>
  (two-columns / three-columns / four-columns), which is derived from the
  number of child links. Using real elements instead of CSS column-count lets
  each sub-column size to its own content.
*/

const MEGA_MENU_COLUMN_COUNTS = {
  'two-columns': 2,
  'three-columns': 3,
  'four-columns': 4,
};

function chunkIntoColumns(items, columnCount) {
  const base = Math.floor(items.length / columnCount);
  const remainder = items.length % columnCount;
  const columns = [];
  let index = 0;

  for (let i = 0; i < columnCount; i++) {
    const size = base + (i < remainder ? 1 : 0);
    columns.push(items.slice(index, index + size));
    index += size;
  }

  return columns;
}

function splitCategory(category) {
  if (category.dataset.columnsBuilt === 'true') return;

  const columnCount = MEGA_MENU_COLUMN_COUNTS[
    Object.keys(MEGA_MENU_COLUMN_COUNTS).find((name) => category.classList.contains(name))
  ];
  if (!columnCount) return;

  const sourceList = category.querySelector(':scope > ul');
  if (!sourceList) return;

  const items = Array.from(sourceList.children);
  if (items.length === 0) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'mega-menu__columns';

  chunkIntoColumns(items, columnCount).forEach((columnItems) => {
    const list = document.createElement('ul');
    list.className = 'mega-menu__column list-unstyled';
    list.setAttribute('role', 'list');
    columnItems.forEach((item) => list.appendChild(item));
    wrapper.appendChild(list);
  });

  sourceList.replaceWith(wrapper);
  category.dataset.columnsBuilt = 'true';
}

function buildMegaMenuColumns(root = document) {
  root.querySelectorAll('.mega-menu__list > li').forEach(splitCategory);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => buildMegaMenuColumns());
} else {
  buildMegaMenuColumns();
}

// Re-run when the theme editor re-renders the header section.
document.addEventListener('shopify:section:load', (event) => {
  buildMegaMenuColumns(event.target);
});
